module.exports = __webpack_public_path__ + "1e14701bfbc0f58c9ddbb610047393fa.svg";